module.exports = __webpack_public_path__ + "img/login-pc.4eb9f380.svg";